'use client'

import { AllHTMLAttributes } from 'react'

import isNumber from 'lodash/fp/isNumber'
import omit from 'lodash/fp/omit'

import type { ChildrenProps } from '../types'

import useViewportSize from '../hooks/useViewportSize'

export default function ViewportWrapper({
  children,
  ...props
}: AllHTMLAttributes<HTMLDivElement> & ChildrenProps) {
  const { height = -1 } = useViewportSize() ?? {}

  const style = {
    ...props.style,
    ...(isNumber(height) && !Number.isNaN(height) && height > 0
      ? {
          height: `${height}px`,
          maxHeight: `${height}px`,
        }
      : {
          height: `100%`,
        }),
  }

  return (
    <div
      className="h-screen overflow-y-auto overflow-x-hidden"
      style={style}
      {...omit(['style'], props)}
    >
      {children}
    </div>
  )
}
